<div class="text-template-container">
  <dx-select-box
    *ngIf="templates.length"
    class="template-select"
    [dataSource]="templates"
    displayExpr="name"
    valueExpr="id"
    [placeholder]="'TEXT-TEMPLATES.USE-TEXT-TEMPLATE' | translate"
    [(value)]="selectedId"
    (onValueChanged)="onTemplateChanged($event)"
  ></dx-select-box>
  <dx-button
    [text]="'TEXT-TEMPLATES.SAVE-AS-TEMPLATE' | translate"
    type="default"
    class="template-button"
    [disabled]="!hasContent(content)"
    (onClick)="onSaveClick()"
  ></dx-button>
</div>

@if(showSaveTemplateModal) {
  <app-save-text-template-modal
    [(showModal)]="showSaveTemplateModal"
    [type]="type"
    [content]="content!"
    (onSave)="onTextTemplateSaved($event)"
  ></app-save-text-template-modal>
}
